import * as React from 'react';
const SvgArrowBackLeft = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 12, height: 18, fill: "none" }, props),
    React.createElement("g", { clipPath: "url(#arrow_back_left_svg__a)" },
        React.createElement("path", { fill: "#fff", d: "M11.368 2.525 8.878 0 0 9l8.877 9 2.491-2.525L4.982 9l6.386-6.475Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "arrow_back_left_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h11.368v18H0z" })))));
export default SvgArrowBackLeft;
